import React, { Component } from "react";
import { leadID } from "../Services/fetchService";
import { DomField, DomSelect, DomBoolCheckbox, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue } from "../Services/Validation";
import { GA_Push } from "../Services/GoogleAnalytics";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import ModalVideo from "react-modal-video";
import "whatwg-fetch";
import "./Body.scss";

export default class Body extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      isBusy: false,
      isLoading: false,
      pageStyle: "form",
      // pageStyle: "done",
      // pageStyle: "already",
      FileName: {
        value: "",
        name: "FileName",
        error: "",
        isRequired: false,
        shouldValidate: false,
        ImagePlaceholder: "אנא צרפו תמונה של המשפחה"
      },
      captchaEnable: !Environment().isLocalhost
    };
    window.sendCallback = this.sendForm;
  }

  componentDidMount() {
    (() => {
      if (window.document.getElementById("GoogleRecap")) return;

      var script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "GoogleRecap";
      script.async = 1;
      script.defer = 1;
      script.src = "https://www.google.com/recaptcha/api.js";

      document.getElementsByTagName("head")[0].appendChild(script);
    })();
    // window.dataLayer.push({ hostname: window.parent.href, formOwner: "YIT" });
  }

  addState = (stateName, isRequired, shouldValidate) => {
    this.setState({
      [stateName]: {
        name: stateName,
        value: "",
        isRequired: !isRequired ? false : true,
        shouldValidate: !shouldValidate ? false : true
      }
    });
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: {
        ...this.state[event.target.name],
        error: "",
        value:
          event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value
      }
    });
  };

  componentDidUpdate() {
    const buttonEl = document.querySelector(".button-text");
    if (this.state.PhoneNumber && this.state.FullName && this.state.pageStyle === "form") {
      if (this.state.PhoneNumber.value !== "" && this.state.FullName.value !== "") {
        buttonEl.classList.add("active");
      } else {
        buttonEl.classList.remove("active");
      }
    }
  }

  setErrorMessage = (target, errorMsg) => {
    console.log(target);
    if (!this.state[target.name]) return;

    this.setState({
      [target.name]: {
        ...target,
        error: errorMsg
      }
    });
  };

  openModal = () => this.setState({ isOpen: true });

  setPage = pageStyle =>
    this.setState({
      pageStyle: pageStyle
    });

  checkString = event => {
    let { name, value } = event.target;
    switch (name) {
      default:
        return value;
      // case "PhoneNumber":
      // case "Age":
      //   return this.onlyNumbers(value)
      // case "FullName":
      //   return this.onlyLetters(value)
    }
  };

  onlyLetters = string => string.replace(/[0-9]/i, "");

  onlyNumbers = string => string.replace(/[+\\/!*@#$%^&a-zA-Z\-\u0590-\u05FF]/i, "");

  changeImageLabel = event => {
    var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
    var file = event.target.files[0];
    if (file) {
      if (file.size > 5242880) {
        alert("לא ניתן להעלות קבצים מעל 5mb");
        event.target.value = "";
        return false;
      }

      var isAllowd = false;
      allowdExtensions.forEach(extension => {
        if (file.type.indexOf(extension) > -1) {
          isAllowd = true;
        }
      });

      if (!isAllowd) {
        alert("ניתן לעלות רק קבצי תמונה");
        event.target.value = "";
        return false;
      }

      this.setState({
        FileName: {
          ...this.state.FileName,
          name: file.name,
          value: file,
          error: "",
          label: "",
          ImagePlaceholder: file.name,
          id: "FileName"
        }
      });
    } else {
      return false;
    }
  };

  saveAndValidate = async () => {
    if (this.state.isBusy) return;

    this.setState({
      isLoading: true,
      isBusy: true
    });

    let isError = false,
      j = 0,
      jsonBody = {},
      stateValidate = Object.filter(this.state, s => s.shouldValidate),
      state = Object.filter(this.state, s => s.isRequired),
      fieldstateValidateKeys = Object.keys(stateValidate),
      fieldStateKeys = Object.keys(state);

    for (let s in stateValidate) {
      if (await !checkInput(stateValidate[s], this.setErrorMessage)) isError = true;
      j++;
    }

    for (let k in fieldStateKeys) {
      jsonBody = Object.assign(jsonBody, {
        [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
      });
    }

    if (isError && j == fieldstateValidateKeys.length) {
      this.setState({
        isLoading: false,
        isBusy: false
      });
      GA_Push("Form_Events", "Form Submission", "Fail", "Forms");
      return;
    }

    this.setState(
      {
        jsonBody,
        isLoading: true,
        isBusy: true
      },
      () => (this.state.captchaEnable ? window.grecaptcha.execute() : this.sendForm())
    );
  };

  sendForm = async () => {
    let formData = new FormData();
    let formDataEmailPhone = new FormData();
    const { jsonBody } = this.state;

    formData.append("LeadID", leadID.toString());
    formDataEmailPhone.append("LeadID", leadID.toString());
    for (let k = 0; k < Object.keys(jsonBody).length; k++) {
      let _key = Object.keys(jsonBody)[k];
      formData.append(_key, jsonBody[_key]);
      if (_key == "PhoneNumber" || _key == "Email") {
        formDataEmailPhone.append(_key, jsonBody[_key]);
      }
    }
    formData.append("Email", formData.get("PhoneNumber"));

    this.state.captchaEnable ? window.grecaptcha.reset() : null;

    let isExists = await fetch(`${apiURL}IsExists`, {
      method: "POST",
      body: formDataEmailPhone
    }).then(data => data.json());

    if (isExists) {
      this.setState({
        isLoading: false,
        isBusy: false,
        pageStyle: "already"
      });
      GA_Push("Form_Events", "Form Submission", "Fail", "Forms");
      return;
    }

    fetch(`${apiURL}Save`, {
      method: "POST",
      body: formData
    })
      .then(data => data.json())
      .then(data => {
        this.setState({
          isLoading: false,
          isBusy: false,
          pageStyle: "done"
        });
        GA_Push("Form_Events", "Form Submission", "Success", "Forms");
        // GA_Push("GA_Events", "form_sent");
        if (this.state.captchaEnable) {
          window.grecaptcha.reset();
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isBusy: false
        });
      });
  };
  render() {
    return (
      <section className={`section-form ${this.state.pageStyle}`}>
        <Loading showLoading={this.state.isLoading} />

        <div className="padding">
          <div className="container">
            {this.state.pageStyle === "form" && (
              <div className="lead-text">
                יש לכם פרויקט?
                <br />
                בואו נתחיל<span>.</span>
              </div>
            )}

            <div className="form">
              {this.state.pageStyle === "form" ? (
                <div className="form">
                  <div className="row ">
                    <div className="field">
                      <DomField
                        type="text"
                        max={64}
                        label="שם מלא"
                        name="FullName"
                        id="FullName"
                        isRequired
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="field">
                      <DomField
                        type="tel"
                        max={64}
                        label="מספר טלפון"
                        name="PhoneNumber"
                        id="PhoneNumber"
                        isRequired
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                      />
                    </div>
                  </div>
                  {/* Button */}
                  <div
                    className="button"
                    onClick={() => {
                      this.saveAndValidate();
                    }}
                  >
                    <div className="button-text">שליחה</div>
                    <div
                      className="g-recaptcha"
                      data-callback="sendCallback"
                      data-size="invisible"
                      data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"
                    ></div>
                  </div>
                  {/* End Button */}
                </div>
              ) : (
                <div className="form thankyou">
                  <div className="container thankyou">
                    <div className="lead-text thankyou">
                      תודה שפניתם אלינו נציג YIT יחזור אליכם בהקדם
                      <i style={{ color: "#ed1c24", marginRight: "3px" }} class="fas fa-exclamation"></i>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="more-info">
              אפשר גם במייל <a href="mailto:info@yit.co.il">info@yit.co.il</a> <br />
              אנחנו תמיד נשמח לדבר
            </div>
          </div>
        </div>
      </section>
    );
  }
}

/*
 <div className="row">
                <div className="button" onClick={() => {
                  this.saveAndValidate()
                }}>
                  <div className="button-text">שלח/י</div>
                  <div className="g-recaptcha"
                    data-callback="sendCallback"
                    data-size="invisible"
                    data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                </div>
              </div>
*/



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx